import { render, staticRenderFns } from "./Freelancers.vue?vue&type=template&id=445ebb5a"
import script from "./Freelancers.vue?vue&type=script&lang=js"
export * from "./Freelancers.vue?vue&type=script&lang=js"
import style0 from "./Freelancers.vue?vue&type=style&index=0&id=445ebb5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports